import React, { memo } from 'react';
import styled from 'styled-components';
import { ArrowIconProps } from '../types';

export const arrowDirections = {
    down: 0,
    left: 90,
    up: 180,
    right: 270
};

export const ArrowIcon = memo(({ 
    width = 10, 
    height = 6, 
    strokeColor = '#666666', 
    fillColor = '#666666', 
    arrowDirection = arrowDirections.down 
}: ArrowIconProps) => {
    return (
        <OuterSvg
            width = {width}
            height = {height}
            stroke = {strokeColor}
            fill = {fillColor}
            viewBox = '0 0 9.9 5.1'
            currentRotation = {arrowDirection}
        >
            <g>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M4.4,4.3L9,0.1C9.2,0,9.4,0,9.6,0.1l0.3,0.2c0.1,0.1,0.1,0.3,0,0.5L5.2,5
                            C5.1,5.1,4.8,5.1,4.7,5L4.4,4.8C4.3,4.6,4.3,4.4,4.4,4.3L4.4,4.3z'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M0.4,0.1C0.5,0,0.8,0,0.9,0.1l4.6,4.2c0.1,0.1,0.1,0.3,0,0.5L5.2,5
                            C5.1,5.1,4.8,5.1,4.7,5L0.1,0.8C0,0.7,0,0.5,0.1,0.3L0.4,0.1L0.4,0.1L0.4,0.1z'
                />
            </g>
        </OuterSvg>
    );
});

const OuterSvg = styled.svg<any>`
    transition: all 0.25s ease-out;
    transform: ${({ currentRotation }) => currentRotation ? `rotate(${currentRotation}deg)` : ''}
`;
